export const getResponsibilityPermalink = (ouSearchDocument) => {
  // Ifs can be removed if Search Api is adapted to
  if (ouSearchDocument.type === 'KOEPEL') {
    return `/sam/organisationalunits/${ouSearchDocument.key}`;
  }
  if (ouSearchDocument.$$meta.permalink.match(/\/organisations\//)) {
    return `/kathondvla/organisationalunits/${ouSearchDocument.key}`;
  }
  return ouSearchDocument.$$meta.permalink;
};

export const getDepeprecatedOrganisationHref = (ouSearchDocument) => {
  if (ouSearchDocument.$$meta.permalink.match(/\/kathondvla\//)) {
    return `/organisations/${ouSearchDocument.key}`;
  }
  if (ouSearchDocument.type === 'KOEPEL') {
    return `/sam/organisationalunits/${ouSearchDocument.key}`;
  }
  if (
    ['SCHOOL', 'BOARDING', 'SCHOOLCOMMUNITY'].some((ouType) => ouType === ouSearchDocument.type)
  ) {
    return ouSearchDocument.$$meta.vosPermalink;
  }
  return ouSearchDocument.$$meta.permalink;
};

export const getPositionDefinition = (position, ouType, mainstructures) => {
  return position.definitions.filter(
    (definition) =>
      definition.applicableIn.ouTypes.some((type) => ouType === type) &&
      (!definition.applicableIn.mainstructures ||
        !mainstructures ||
        mainstructures.some((ms) =>
          definition.applicableIn.mainstructures.some((defMs) => defMs === ms)
        ))
  )[0];
};

export const getRequestDescription = (request) => {
  const ouName = request.organisationalUnit.$$expanded.$$displayName;
  return `${request.from.$$expanded.firstName} ${request.from.$$expanded.lastName}${
    request.position ? ` als ${request.position.$$expanded.name}` : ''
  } in ${ouName}`;
};
